import { call, put, takeEvery } from 'redux-saga/effects';
import { REMOVE_USER_ADDRESS_REQUEST } from '../../constants/user_address.constants';
import { removeUserAddress } from '../../../requests/user_addresses_requests/remove_user_addresses_request';
import { removeUserAddressRequestSuccess, removeUserAddressRequestFailure } from '../../actions/user_addresses_actions/common_export';
import { message_success, message_error } from '../../../../../../components/Message';

function* removeUserAddressRequest({ address_id, user_id }) {
    const {
        result, options, msg, error,
    } = yield call(removeUserAddress, address_id, user_id);
    if (result) {
        yield put(removeUserAddressRequestSuccess(options.person.addresses));
        message_success('Address removed successfully!');
    } else {
        yield put(removeUserAddressRequestFailure(error));
        message_error(msg);
    }
}

export default function* removeUserAddressSaga() {
    yield takeEvery(REMOVE_USER_ADDRESS_REQUEST, removeUserAddressRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_addresses_sagas/remove_user_address.saga.js